import React from 'react';
import { RouteComponentProps, StaticContext, withRouter } from 'react-router';
import OrderContentLogItem from '../../components/OrderContentLogItem/OrderContentLogItem';
import { defaultPagination } from 'src/constants/main';
import client from 'src/services/client';
import { IPagination } from 'src/types/main';
import { TOrderContentLog } from 'src/types/orders';
import ScrollableList from 'src/view/components/ScrollableList/ScrollableList';
import logger from '~/services/logger';

type TProps = RouteComponentProps<{ id: string }, StaticContext, undefined>;

interface IState {
  pagination: IPagination<TOrderContentLog | undefined>;
  selected: null | number;
  pages: number[];
}

class OrderContentLogsList extends React.Component<TProps, IState> {
  state = {
    pagination: defaultPagination,
    selected: null,
    pages: [],
  };

  fetchList = async (page: number = this.state.pagination.current_page + 1) => {
    try {
      if (typeof page !== 'number') page = this.state.pagination.current_page + 1;

      this.setState((state) => ({ pagination: { ...state.pagination, loading: true, refreshing: page === 1 } }));
      const pagination: IPagination<TOrderContentLog> = await client.get(`/v3/orders/${this.props.match.params.id}/logs`, {
        params: {
          page,
          details: 1,
          action: 'order_diff',
        },
      });
      this.setState((state) => ({
        ...state,
        pagination: {
          ...pagination,
          loading: false,
          refreshing: false,
          data: this.state.pages.length ? [...this.state.pagination.data, ...pagination.data] : pagination.data,
        },
        pages: [...state.pages, pagination.current_page].sort((a, b) => (a > b ? 1 : -1)),
      }));
    } catch (error: any) {
      this.setState((state) => ({ pagination: { ...state.pagination, loading: false, refreshing: false } }));
      logger.error({ error, place: 'OrderContentLogsList fetchList' });
    }
  };

  select = (index: number | null) => {
    this.setState({ selected: index });
  };

  renderLog = (log: TOrderContentLog | undefined, index: number, selected: boolean) => (
    <OrderContentLogItem key={index} index={index} log={log} selected={selected} select={this.select} />
  );

  render() {
    return (
      <div className="d-flex flex-1 px-8 pt-6 pb-8">
        <ScrollableList
          autoFetch
          listClassName=""
          fetch={this.fetchList}
          list={this.state.pagination.data}
          loading={this.state.pagination.loading}
          refreshing={this.state.pagination.refreshing}
          current_page={this.state.pagination.current_page}
          last_page={this.state.pagination.last_page}
          renderItem={(item, index) => this.renderLog(item, index, this.state.selected === index)}
          emptyListText="no_more_logs"
          scrollToTop
          pages={this.state.pages}
        />
      </div>
    );
  }
}

export default withRouter(OrderContentLogsList);
